import { FB_OAUTH_ENDPOINT } from "../../constants";
import { FaFacebookF } from "react-icons/fa";
import clsx from "clsx";

export function FacebookButton() {
  const handleClick = () => {
    const width = 600;
    const height = 700;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;

    window.open(
      FB_OAUTH_ENDPOINT,
      "facebookOAuth",
      `width=${width},height=${height},top=${top},left=${left}`
    );
  };

  const baseClasses = clsx(
    "flex items-center justify-center w-full gap-3 rounded-xl px-4 py-3 text-sm font-medium text-white shadow-sm transition-all duration-200",
    "bg-[#1877F2] border border-[#1877F2]",
    "hover:bg-[#155db8] hover:shadow-md hover:scale-[1.02]",
    "active:scale-[0.98]"
  );

  return (
    <button onClick={handleClick} type="button" className={baseClasses}>
      <FaFacebookF className="w-5 h-5" />
      <span>Continue with Facebook</span>
    </button>
  );
}